import type {
  CreateInvoiceInput,
  DeleteRecordsInput,
  InvoiceBulkPatch,
  ReplaceInvoiceLineItemsInput,
  UpdateInvoiceInput
} from '@shared/types';
import { showUndoToastForLastAction } from '@renderer/app/undo/undo-toast';
import { getDesktopApi } from '@renderer/lib/desktop-api';

export async function listInvoices() {
  return getDesktopApi().invoices.listInvoices();
}

export async function getInvoiceById(invoiceId: string) {
  return getDesktopApi().invoices.getInvoiceById(invoiceId);
}

export async function deleteInvoices(payload: DeleteRecordsInput) {
  const result = await getDesktopApi().invoices.deleteInvoices(payload);
  void showUndoToastForLastAction();
  return result;
}

export async function listDeletedInvoices() {
  return getDesktopApi().invoices.listDeletedInvoices();
}

export async function restoreInvoices(payload: DeleteRecordsInput) {
  return getDesktopApi().invoices.restoreInvoices(payload);
}

export async function purgeInvoices(payload: DeleteRecordsInput) {
  return getDesktopApi().invoices.purgeInvoices(payload);
}

export async function createInvoice(payload: CreateInvoiceInput) {
  return getDesktopApi().invoices.createInvoice(payload);
}

export async function updateInvoice(payload: UpdateInvoiceInput) {
  const result = await getDesktopApi().invoices.updateInvoice(payload);
  void showUndoToastForLastAction();
  return result;
}

export async function applyBulkInvoicePatch(payload: InvoiceBulkPatch) {
  const result = await getDesktopApi().invoices.applyBulkPatch(payload);
  void showUndoToastForLastAction();
  return result;
}

export async function replaceInvoiceLineItems(payload: ReplaceInvoiceLineItemsInput) {
  const result = await getDesktopApi().invoices.replaceInvoiceLineItems(payload);
  void showUndoToastForLastAction();
  return result;
}

export async function syncInvoiceToOblio(invoiceId: string) {
  return getDesktopApi().invoices.syncInvoiceToOblio({ invoiceId, documentKind: 'invoice' });
}
